<form [formGroup]="form">
	<mat-list-item class="input">
		<input
			matInput
			type="text"
			placeholder="Enter merchant"
			formControlName="merchantControl"
			(keyup.enter)="filter()" />
	</mat-list-item>
</form>
